import "./TheReel.module.css";
import Header from "@/reusable_sections/Header";
import FishArchive from "./sections/FishArchive";
import VictoryMetrics from "./sections/VictoryMetrics";
import Footer from "@/reusable_sections/Footer";
export default function TheReelPage() {
  return <div>
      <Header />
      <FishArchive />
      <VictoryMetrics />
      <Footer />
    </div>;
}